module.exports = __webpack_public_path__ + "static/IMG_1528-f7a8da9547e0701d895a7f31b40090a8.jpeg";